import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/Button';

/**
 * Honest 404 for unknown routes. Replaces the previous silent redirect
 * to /dashboard so a mistyped or dead URL is visible rather than swallowed.
 */
export function NotFoundPage(): JSX.Element {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="flex min-h-dvh items-center justify-center bg-tg-page p-6 text-tg-ink">
            <div className="w-full max-w-md rounded-2xl border border-tg-border bg-white p-8 text-center shadow-[var(--tg-shadow-card)]">
                <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-tg-info/10 text-tg-info">
                    <Compass className="h-6 w-6" />
                </div>
                <p className="mt-4 text-3xl font-bold">404</p>
                <h1 className="mt-1 text-lg font-semibold">
                    {t('errors.notFound.title', { defaultValue: 'Page not found' })}
                </h1>
                <p className="mt-2 text-sm text-tg-muted">
                    {t('errors.notFound.description', {
                        defaultValue: 'The page you are looking for does not exist or has moved.',
                    })}
                </p>
                <Button className="mt-6 w-full" variant="default" onClick={() => navigate('/dashboard')}>
                    {t('errors.notFound.backToDashboard', { defaultValue: 'Back to dashboard' })}
                </Button>
            </div>
        </div>
    );
}
